import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'fol-decision-error',
  imports: [MatButton, RouterLink, TranslatePipe],
  templateUrl: './decision-error.component.html',
  styleUrl: './decision-error.component.scss'
})
export class DecisionErrorComponent {}
